import styled from 'styled-components';

export const Title = styled.h2`
  font-size: 2.875rem;
  font-weight: bold;
`;

export const Description = styled.p`
  font-size: 14px;
  text-align: left;
`;

export const Label = styled.label`
  font-size: 14px;
  font-weight: 500;
`;

export const Input = styled.input`
  font-size: 14px;
  border-radius: 4px;
`;

export const Select = styled.select`
  font-size: 14px;
  border-radius: 4px;
`;

export const Textarea = styled.textarea`
  font-size: 14px;
  border-radius: 4px;
`;

export const Section = styled.section`
  &.section {
    margin-bottom: 5px;
  }
`;